import React, { useEffect, useState, useContext } from 'react';
import {
  Table,
  Spinner,
  Alert,
  Button,
  Modal,
  InputGroup, 
  Form, 
} from 'react-bootstrap';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Pagination from 'react-bootstrap/Pagination';
//  import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

 
const PendingApproval = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [filteredRestaurants, setFilteredRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const [searchRestaurantName, setSearchRestaurantName] = useState('');
  const [payInfo, setPayInfo] = useState({});
  const [refresh, setRefresh] = useState(false);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 
//   const { permissionsAccess } = useContext(PermissionContext);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  
 
  const fetchData = async () => {
    setLoading(true);
    setError(null);
  
    try {
      const formData = new FormData();
      formData.append('country_id', countryid);
      const response = await fetch(`${apiGlobal}restaurant_account_pending_list.php`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
  
      if (data?.status && data?.message === 'Success') {
        setRestaurants(data.data);
        setFilteredRestaurants(data.data);
       } else if (data?.status && data?.message === 'No data found') {
        setRestaurants([]);
        setFilteredRestaurants([]);
      } else {
        setRestaurants([]);
        setFilteredRestaurants([]);
        setError(data?.message || 'Unexpected error');
      }
    } catch (err) {
      setError('Failed to fetch restaurant account data');
    } finally {
      setLoading(false);
    }
  };
  
 
  // Fetch data on mount and when refresh state changes
  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.adminAccountPendingApprovalRefresh]);

  // Apply filters whenever search inputs change
  useEffect(() => {
    if (restaurants.length > 0) {
      const filtered = restaurants.filter((restaurant) => {
        const nameMatch = restaurant?.restaurantName.toLowerCase().includes(searchRestaurantName.toLowerCase());
        return nameMatch;
      });
      setFilteredRestaurants(filtered);
      // Reset to first page when filters change
      setCurrentPage(1);
    }
  }, [searchRestaurantName, restaurants]);

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };


  const clearFilters = () => {
    setSearchRestaurantName('');
  };
 
  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRestaurants = filteredRestaurants.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredRestaurants.length / itemsPerPage);

  // Spinner while loading
  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="grow" variant="primary" />
      </div>
    );
  }
 
  // Error display
  if (error) {
    return (
      <Alert variant="danger" className="text-center mt-4">
        {error}
      </Alert>
    );
  }
 
  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
        marginLeft: '15px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Restaurant Account</Typography>
        <Typography sx={{ color: 'text.primary' }}>Pending Approval</Typography>
      </Breadcrumbs>
      

      <div className="container">
        <div
          className="mb-4"
          style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
        >
          <h5
            className="mb-0"
            style={{
            color: '#495057',
            marginRight: '20px',
            fontWeight: '600',
          }}
          >
            Filter Payment
          </h5>
          <div 
            style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px', 
            flexWrap: 'wrap', 
          }}
          >
            <InputGroup style={{ maxWidth: '200px' }}>
              <Form.Control
                type="text"
                placeholder="Search by Restaurant Name"
                value={searchRestaurantName}
                onChange={e => setSearchRestaurantName(e.target.value)}
                style={{
                borderRadius: '25px',
                padding: '8px',
                border: '1px solid #ddd',
              }}
              />
            </InputGroup>

            <Button
              variant="outline-danger"
              style={{
              borderRadius: '25px',
              padding: '8px 16px',
            }}
              onClick={clearFilters}
            >
              Clear Filters
            </Button>

            <Button
              variant="outline-danger"
              style={{
              borderRadius: '25px',
              padding: '8px 16px',
            }}
              onClick={() => setRefresh(prev => !prev)}
            >
              Refresh
            </Button>
          </div>
        </div>

        {filteredRestaurants.length === 0 ? (
          <div className="text-center">No Pending Payment Approval found.</div>
        ) : (
          <Table
            responsive
            style={{
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <thead className="bg-warning" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>Sr.no</th>
                <th>Payment Date</th>
                <th>Restaurant Name</th>
                {/* <th>Gross Amount (₹)</th> */}
                <th>Paid Amount (₹)</th>
                {/* <th>Balance (₹)</th> */}
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentRestaurants.map((restaurant, index) => (
                <tr key={restaurant.id} style={{ textAlign: 'center', padding: '20px' }}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{formatDate(restaurant.payment_date)}</td>
                  <td>{restaurant?.restaurantName}</td>
                  {/* <td>₹{parseFloat(restaurant?.gross_amount || 0).toLocaleString()}</td> */}
                  <td>₹{parseFloat(restaurant?.amount || 0).toLocaleString()}</td>
                  {/* <td>₹{parseFloat(restaurant?.balance || 0).toLocaleString()} {restaurant?.balance_label}</td> */}
                  <td><span className="text-danger">Pending Approval</span></td>
                  <td>
                    <Button 
                      type="button"
                      variant="outline-danger"
                      size="sm"
                      onClick={() => setPayInfo({
                        showModal: true,
                        paytype: restaurant.payment_type || 'NA',
                        paymentDate: restaurant.payment_date || 'NA',
                        paymentAmount: restaurant.amount || 'NA',
                        refNo: restaurant.ref_no || 'NA',
                        narration: restaurant.narration || 'NA',
                        bankName: restaurant.bank || 'NA',
                        chequeDate: restaurant.ref_date || 'NA',
                       })}
                    >Pay Info
                    </Button>
                  </td>
                
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <div
          style={{
            bottom: '20px',
            right: '20px',
            zIndex: 999,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {filteredRestaurants.length > 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
              ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
            />
          </Pagination>
          )}
        </div>
      
      </div>
      <Modal
        show={payInfo?.showModal}
        onHide={() => setPayInfo({
            showModal: false,
            paytype: '',
            paymentDate: '',
            paymentAmount: '',
            totalAmount: '',
            refNo: '',
            narration: '',
            bankName: '',
            chequeDate: '',
          })}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Payment Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            responsive
            style={{
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(178, 114, 114, 0.1)',
        }}
          >
            <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>#</th>
                <th>Payment Date</th>
                <th>Payment Type</th>
                <th>Payment Amount</th>
                <th>Narration</th>
                <th>Ref No</th>
                <th>Bank Name</th>
                <th>Cheque Date</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: 'center' }}>
              <tr>
                <td>{1}</td>
                <td>{formatDate(payInfo.paymentDate)}</td>
                <td>
                  {(() => {
                switch (payInfo.paytype) {
                  case '1':
                    return 'Cash';
                  case '3':
                    return 'NEFT/RTGS/IMPS';
                  case '4':
                    return 'On Account';
                  case '5':
                    return 'Cheque';
                  default:
                    return 'Unknown Payment Method';
                }
              })()}
                </td>
                <td>{payInfo.paymentAmount}</td>
                <td>{payInfo.narration}</td>
                <td>{payInfo.paytype !== '1' ? payInfo.refNo : 'NA'}</td>
                <td>{payInfo.paytype === '3' || payInfo.paytype === '5' ? payInfo.bankName : 'NA'}</td>
                <td> {payInfo.paytype === '5' ? formatDate(payInfo.chequeDate) : 'NA'}
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </div>  
  );
};
 
export default PendingApproval;
